import { useContext } from "react";
import DeleteIconSvg from "../../Svg/DeleteIconSvg";
import AlertContext from "../../context/AlertContext";
import { LibraryContext } from "../../context/LibraryContext";

export default function DescriptionHooks() {
  const Alert = useContext(AlertContext);
  const LibraryCxt = useContext(LibraryContext);

  const defaultColumns = [
    {
      title: "Topic",
      editable: false,
      dataIndex: "topicname",
    },
    {
      width: "100px",
      editable: false,
      title: "Complexity",
      dataIndex: "complexity",
    },
    {
      width: "50px",
      title: "Action",
      dataIndex: "Action",
      render: (_, record) => (
        <button
          onClick={() => handleDelete(record.key)}
          style={{ border: "none", background: "none" }}
        >
          <DeleteIconSvg className="red" />
        </button>
      ),
    },
  ];

  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        handleSave,
        title: col.title,
        editable: col.editable,
        dataIndex: col.dataIndex,
      }),
    };
  });

  const handleSave = (row) => {
    const newData = [...LibraryCxt.dataTopicAndComplexity];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];

    newData.splice(index, 1, {
      ...row,
      ...item,
    });

    LibraryCxt.setDataTopicAndComplexity(newData);
  };

  const handleDelete = (key) => {
    const newData = LibraryCxt.dataTopicAndComplexity.filter(
      (item) => item.key !== key
    );

    const topicandcomplexityData = LibraryCxt.topicAndComplexity.filter(
      (item) => item.key !== key
    );

    LibraryCxt.setTopicAndComplexity(topicandcomplexityData);
    LibraryCxt.setDataTopicAndComplexity(newData);
  };

  const handleAdd = (e) => {
    e.preventDefault();
    const topicAndComplexity = JSON.parse(
      JSON.stringify(LibraryCxt.topicAndComplexity)
    );
    if (
      topicAndComplexity.some((item) => item.name === LibraryCxt.topic?.name)
    ) {
      Alert.setShowNotify({
        show: true,
        title: "Warning",
        msg: `Topic "${LibraryCxt.topic?.name}" already added!`,
      });
      return;
    }

    const newKey = LibraryCxt.count + 1;

    const newData = {
      key: newKey,
      topicname: LibraryCxt.topic?.name,
      complexity: LibraryCxt.level?.name,
    };

    const topicData = {
      key: newKey,
      type: LibraryCxt.topic?.type,
      name: LibraryCxt.topic?.name,
      value: LibraryCxt.topic?.value,
      complexity: LibraryCxt.level?.value,
    };

    LibraryCxt.setCount(newKey);
    topicAndComplexity.push(topicData);
    console.log("topicAndComplexity", topicAndComplexity);
    LibraryCxt.setTopicAndComplexity(topicAndComplexity);
    LibraryCxt.setDataTopicAndComplexity((prev) => [...prev, newData]);
    LibraryCxt.setUserInp((pre) => ({
      ...pre,
      secData: {
        ...pre.secData,
        complexityid: topicAndComplexity[0]?.complexity,
      },
    }));

    LibraryCxt.setHandleadd(true);
    LibraryCxt.setReset(true);
  };

  return { columns, handleAdd, handleSave, defaultColumns };
}
